export const buildIssueShortageAlertLines = (data, t) => {
  const referenceCount = data?.reference_count ?? 0;
  const draftCount = data?.draft_count ?? 0;
  const shortage = data?.shortage ?? 0;

  return {
    previousLine: t('Previous issue quantity was {{count}} items.', {
      count: referenceCount,
      defaultValue: `Previous issue quantity was ${referenceCount} items.`,
    }),
    currentLine: t('Current issue quantity is {{count}} items.', {
      count: draftCount,
      defaultValue: `Current issue quantity is ${draftCount} items.`,
    }),
    questionLine: t('Would you like to issue {{count}} additional item(s)?', {
      count: shortage,
      defaultValue: `Would you like to issue ${shortage} additional item(s)?`,
    }),
  };
};

export const buildIssueShortageToastMessage = (data, t) => {
  const lines = buildIssueShortageAlertLines(data, t);
  return `${lines.previousLine}\n${lines.currentLine}\n${lines.questionLine}`;
};

export const shouldShowIssueShortageAlert = (data) =>
  Boolean(data?.show_alert && data?.has_previous_issue);

export const buildIssueShortageSuggestPayload = ({
  zoneId,
  locationId,
  draftCount,
  draftItems = [],
}) => ({
  zone_id: zoneId,
  location_id: locationId,
  draft_count: draftCount,
  draft_items: draftItems,
});
